// Helpers de geometría puros del visor de parque solar (sin estado, sin dependencias del motor de render).

// ¿El punto está dentro del rectángulo {x, y, width, height}?
export function isPointInRect(point, rect) {
  return point.x >= rect.x && point.x <= rect.x + rect.width &&
    point.y >= rect.y && point.y <= rect.y + rect.height
}

// Índice del bloque (polígono) que contiene el punto, iterando de último a primero
// (prioridad visual) con ray-casting. Devuelve null si ninguno.
// `blocks` = array de { points: [x0,y0,x1,y1,...], x?, y? } (último par = cierre).
export function findBlockAtPoint(blocks, point) {
  for (let i = blocks.length - 1; i >= 0; i--) {
    const block = blocks[i]
    if (!block.points || block.points.length < 6) continue

    // Algoritmo ray-casting para punto dentro de poligono
    const pts = block.points
    const numVertices = (pts.length / 2) - 1 // ultimo punto es cierre
    let inside = false

    for (let j = 0, k = numVertices - 1; j < numVertices; k = j++) {
      const xi = pts[j * 2] + (block.x || 0)
      const yi = pts[j * 2 + 1] + (block.y || 0)
      const xk = pts[k * 2] + (block.x || 0)
      const yk = pts[k * 2 + 1] + (block.y || 0)

      if (((yi > point.y) !== (yk > point.y)) &&
          (point.x < (xk - xi) * (point.y - yi) / (yk - yi) + xi)) {
        inside = !inside
      }
    }

    if (inside) return i
  }

  return null
}

// Índice del texto cuyo bounding box (ancho estimado por fontSize) contiene el punto.
// Devuelve null si ninguno. `txtBlocks` = array de { x?, y?, fontSize?, text? }.
export function findTxtAtPoint(txtBlocks, point) {
  for (let i = txtBlocks.length - 1; i >= 0; i--) {
    const txt = txtBlocks[i]
    const x = txt.x || 0
    const y = txt.y || 0
    const fontSize = txt.fontSize || 16
    // Estimar ancho del texto basado en caracteres y fontSize
    const textWidth = txt.text ? txt.text.length * fontSize * 0.6 : 100
    const textHeight = fontSize * 1.4

    if (point.x >= x && point.x <= x + textWidth &&
        point.y >= y && point.y <= y + textHeight) {
      return i
    }
  }
  return null
}
